import React from 'react'
import HttpServices from '../../../utils/Http.services'
import { checkTextTranslation, imageAddress, translate } from '../../../utils/useful'

class FirstStep extends React.Component {
    state = {
        AllApplets: [],
        search: '',

    }
    componentDidMount() {
        this.getAllApplets()
    }
    getAllApplets = () => {
        // console.log("POSTDASH")
        // let info = this.state.info
        // this.setState({ isLoadingPost: true })
        // if (this.state?.applet) {
        //     info.applet = this.state?.applet
        //     info.roles = this.state.roles
        // }

        HttpServices.request("getMyApplets", {}, (fetchResult, fetchError) => {
            this.setState({ isLoadingPost: false })

            // console.log(fetchResult)
            // console.log(fetchError)

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                return
            }
            // if (!info._id) {
            //     info._id = fetchResult.info._id
            //     this.setState({ info })
            // }

            // console.log(fetchResult.info)
            // if (fetchResult.info) {
            // }
            this.setState({ AllApplets: fetchResult.info }, () => {
                console.log('this.state.AllApplets', this.state.AllApplets)
            })
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postSuccesfully', description: '{{lang}}info.postSuccesfullyDesc' })

        })

    }
    nextPage = (item) => {
        this.props.setData(({ applet: item }), () => {
            // this.props.setData(({ applet: item }) => {

            this.props.changeStage('widgets')

        })

    }

    handleSearchBox = (e) => {
        this.setState({ search: e }, () => {
            console.log('this is search:', this.state.search)
            this.searchList()
        })
    }

    searchList = () => {
        let data = [...this.state.AllApplets]

        if (!this.state.fulldata) {
            this.setState({ fulldata: data })
        } else {
            data = this.state.fulldata
        }
        // console.log('data 1', data)
        let temp = []
        // console.log('temp', temp)


        for (let i = 0; i < data.length; i++) {
            console.log('data 2', data[i])
            let content = data[i];
            console.log('content', content)
            if (checkTextTranslation(content.applet?.name).toLowerCase().includes(this.state.search.toLowerCase())) {
                temp.push(content)
            }
        }

        console.log(temp)
        this.setState({ AllApplets: temp });



    }


    render() {
        return (
            <div className="w-100 h-100 scroll-no-scrollbar">

                <div className="px-2 w-100 py-2 position-sticky top-0" style={{ background: 'linear-gradient(to right , #4685cccb,#4646cc)', backgroundColor: '#4646cc' }}>
                    <div className="mb-2">
                        <button onClick={() => this.props.lastStage()} className='flexc'>
                            {/* <div className='rotate-180  br-50 ws-25 hs-25 flexcc' style={{ background: '#ffffffcd' }}>
                                <img className='' src="/assets/icons/useful/angle-right.svg" height={20} />
                                {/* <img className='invert' src="/assets/icons/useful/fi-sr-angle-left.png" height={20} /> 
                            </div> */}
                            <h2 style={{ color: '#ffffffcc', fontSize: 19 }} className="mx-2" >{translate('Select Applet')}</h2>
                        </button>
                        {/* <p style={{ color: '#fff' }}>
                            {translate('Select Applets')}
                        </p> */}
                    </div>
                    <div className='mb-1'>
                        <div style={{ backgroundColor: '#f6f6f6', borderRadius: 6 }}>
                            <input className="py-1 px-2 w-100" onChange={(e) => this.handleSearchBox(e.target.value)} placeholder={translate('Search ...')} style={{ backgroundColor: 'transparent', border: 'none' }} />
                        </div>
                    </div>
                </div>

                {this.state.AllApplets.length == 0 ? (
                    <div className='flexcc w-100 mt-4'>
                        <p>found Nothing</p>
                    </div>
                ) : (


                    this.state.AllApplets.map((data) => {
                        return (
                            <div className="py-2" style={{ cursor: 'pointer', borderBottom: '1px solid #e8e8e8' }} onClick={() => this.nextPage(data)}>
                                {/* <div className="py-2" style={{ cursor: 'pointer', borderBottom: '1px solid #e8e8e8' }} onClick={() => this.props.changeStage('widgets')}> */}
                                {/* <div className="flexcd"> */}
                                <div className='px-2 flexcb'>
                                    <div className='flexc'>
                                        <div className="mrd-3 flexcc" style={{}}>
                                            <img className="br-50" src={imageAddress(data.applet?.image)} style={{ width: '45px', height: 45, }} />
                                        </div>
                                        <div className="d-flex flex-column">
                                            <p className="text-normal">{checkTextTranslation(data?.applet?.name)}</p>
                                            <p className="text-smaller">{checkTextTranslation(data?.appletHub?.fullname)}</p>

                                        </div>
                                    </div>
                                    <div className='  br-50 ws-25 hs-25 flexcc' style={{ background: '#ffffffcd' }}>
                                        <img className='' src="/assets/icons/useful/angle-right.svg" height={20} />
                                    </div>
                                </div>
                                {/* </div> */}
                            </div>

                        )
                    })
                )}

            </div>
        );
    }
}

export default FirstStep;